import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {ErrorMessage, Field} from 'formik';
import InputBox from '../../components/formik/InputBox';
import {Trans} from 'react-i18next';
import freeEmailDomains from '../../utils/config/freeEmailDomains';
import freeEmailDomainsSkincarePro from "../../utils/config/freeEmailDomainsSkincarePro";

export default function EmailField({
  field,
  disabled = false,
  isVerifyFreeDomain = true,
  functionType,
  ...props
}) {
  const [previousValue, setPreviousValue] = useState();
  const [previousError, setPreviousError] = useState();

  const validateEmail = disabled => value => {
    let error = undefined;

    if (disabled) return error;

    if (value && value !== previousValue) {
      const found = value.lastIndexOf('@');
      if (found >= 0) {
        const emailDomain = value.substring(found).toLowerCase();
        const notAllowedEmail = freeEmailDomains;
        if (isVerifyFreeDomain && notAllowedEmail.includes(emailDomain)) {
          error = (
            <Trans i18nKey="c.a.email.field.error.free.email">
              Please fill in your business email address. Public free email is not allowed.
          </Trans>
          );
        }
      }

      setPreviousValue(value);
      setPreviousError(error);
      return error;
    }

    if (!value) {
      setPreviousValue(value);
      setPreviousError(error);
      return error;
    }

    return previousError;
  };

  return (
    <div style={{color: '#fd397a'}}>
      <Field
        {...props}
        disabled={disabled}
        type="email"
        name={field.name}
        autoComplete="off"
        maxLength="200"
        validate={validateEmail(disabled)}
        component={InputBox}
      />
      <ErrorMessage name={field.name} />
    </div>
  );
}

EmailField.propTypes = {
  disabled: PropTypes.bool,
};
